export const designationEndpoints = (builder) => ({
    getDesignationList: builder.query({
        query: (args = {}) => ({
            url: "/admin/designation-list",
            method: "GET",
            params: args,
        }),
        providesTags: ["Designation"],
    }),

    saveDesignation: builder.mutation({
        query: (data) => ({
            url: "/admin/designation",
            method: "POST",
            body: data,
        }),
        invalidatesTags: ["Designation"],
    }),

    deleteDesignation: builder.mutation({
        query: (id) => ({
            url: `/admin/designation/${id}`,
            method: "DELETE",
        }),
        invalidatesTags: ["Designation"],
    }),
});